import { Injectable } from '@angular/core';
import { objectToCamel } from 'ts-case-convert';
import { lastValueFrom } from 'rxjs';
import { ClientHttpService } from './client.http.service';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(private clientHttpService: ClientHttpService) {}

  async getServices(clientId: number) {
      
    const source$ = this.clientHttpService.getServiceInfos(clientId);
    const response = await lastValueFrom(source$);
    const services = objectToCamel(response as object);
    return this.getData(services);
  }

  getData(response: any) {
    return response.data;
  }
}
